import { bool, func, number, node, oneOf, string } from 'prop-types'
import { PureComponent, Fragment } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Toolbar from '../Toolbar'
import { kuiperClassNames } from '../utils'
import './styles.scss'

class Toast extends PureComponent {
  static propTypes = {
    actionRequired: bool,
    animationDirection: oneOf(['up', 'down']),
    centerChildren: node,
    children: node,
    className: string,
    delay: number,
    isOpen: bool,
    leftChildren: node,
    onClose: func,
    rightChildren: node,
  }

  static defaultProps = {
    actionRequired: false,
    animationDirection: 'up',
    delay: 3000,
  }

  componentWillUnmount() {
    if (this.closeTimeout) clearTimeout(this.closeTimeout)
  }

  setCloseTimeout = () => {
    if (!this.props.actionRequired) {
      clearTimeout(this.closeTimeout)
      this.closeTimeout = this.closeTimer()
    }
  }

  closeTimer = () =>
    setTimeout(() => {
      this.props.onClose()
    }, this.props.delay)

  render() {
    const {
      animationDirection,
      centerChildren,
      className,
      children,
      isOpen,
      leftChildren,
      rightChildren,
    } = this.props

    if (isOpen) {
      this.setCloseTimeout()
    }

    return (
      <Fragment>
        <TransitionGroup className={kuiperClassNames('toast-transition-group')}>
          {isOpen && (
            <CSSTransition classNames="kuiper-toast-slide" timeout={350}>
              <div
                className={kuiperClassNames(
                  'toast-wrapper',
                  `slide-${animationDirection}`,
                  className
                )}
              >
                <div
                  className={kuiperClassNames('toast')}
                  onMouseEnter={this.setCloseTimeout}
                >
                  <Toolbar
                    centerChildren={centerChildren || children}
                    leftChildren={leftChildren}
                    rightChildren={rightChildren}
                    classes={kuiperClassNames('toast-internals')}
                  />
                </div>
              </div>
            </CSSTransition>
          )}
        </TransitionGroup>
      </Fragment>
    )
  }
}

export default Toast
